<template>
    <q-layout view="lHh Lpr lFf">
      <router-view />
    </q-layout>
  </template>
  
  <script setup>
  </script>